<template>
  <div style="display: none">
    <button id="btn" @click="toMeiQia" />
  </div>
</template>

<script>

import { MeiQiaEntId, MeiQiaLoader, MeiQiaToken } from '@/utils/routeList'

export default {
  name: 'Index',
  data() {
    return {
      'meiQiaInfo': {
        code: 0, // 成功返回0，失败返回值 < 0
        data: {}, // 成功返回相应的数据，失败返回 null
        message: 'string' // 成功无该字段，失败返回相应的错误信息
      }
    }
  },
  computed: {
    unserInfo() {
      return this.$route.query.Dcode
    }
  },
  mounted() {
    this.handleInfoList()
    this.init()
    // eslint-disable-next-line no-undef
    _MEIQIA('hidePanel')
  },

  methods: {
    /* 用户信息*/
    handleInfoList() {
      this.$api('USER_INFO_H5').then((res) => {
        this.userInfoList = res.result
      })
    },
    init() {
      (function(a, b, c, d, e, j, s) {
        a[d] = a[d] || function() {
          (a[d].a = a[d].a || []).push(arguments)
        }
        j = b.createElement(c)
        s = b.getElementsByTagName(c)[0]
        j.async = true
        j.charset = 'UTF-8'
        j.src = MeiQiaLoader
        s.parentNode.insertBefore(j, s)
      })(window, document, 'script', '_MEIQIA')
      // eslint-disable-next-line no-undef
      _MEIQIA('entId', MeiQiaEntId)
      // eslint-disable-next-line no-undef
      _MEIQIA('assign', {
        agentToken: MeiQiaToken
      })

      // eslint-disable-next-line no-undef
      _MEIQIA('withoutBtn')
    },
    toMeiQia() {
      const { name, phonenum, hospitalName, hospitalDepartment, hospitalPosition, hospitalAddress } =
        this.userInfoList
      // eslint-disable-next-line no-undef
      _MEIQIA('metadata', {
        '姓名': name,
        '电话号': phonenum,
        '所属医院': hospitalName,
        '医院科室': hospitalDepartment,
        '所属职位': hospitalPosition,
        '所属地址': hospitalAddress
      })
      // eslint-disable-next-line no-undef
    }

  }

}
</script>
